//文字コードはutf-8

/* うみにん図鑑 ページャー（クライアントサイド・ページング）
========================================================*/

export function initUmininDex() {
    const containers = document.querySelectorAll('.jsUmininDex');
    if (!containers.length) return;

    containers.forEach(container => {
        const pageLinks = container.querySelectorAll('[data-page-target]');
        const pageItems = container.querySelectorAll('.modPagination__pages__item');
        const prevBtn = container.querySelector('[data-page-prev]');
        const nextBtn = container.querySelector('[data-page-next]');
        const totalPages = pageItems.length;
        if (!totalPages) return;

        function getHeaderOffset() {
            const nav = document.querySelector('.header__nav');
            return nav ? nav.getBoundingClientRect().height : 0;
        }

        function scrollToContainer() {
            const offset = getHeaderOffset() + 16; // 16px breathing room below the header
            const top = container.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        }

        function setPage(page, opts) {
            page = Math.max(1, Math.min(totalPages, page));
            container.dataset.currentPage = String(page);

            pageItems.forEach((item, idx) => {
                item.classList.toggle('modPagination__pages__item--current', idx + 1 === page);
            });

            if (prevBtn) prevBtn.toggleAttribute('hidden', page === 1);
            if (nextBtn) nextBtn.toggleAttribute('hidden', page === totalPages);

            if (opts && opts.scroll) {
                scrollToContainer();
            }
        }

        pageLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                const target = parseInt(link.dataset.pageTarget, 10);
                if (!Number.isNaN(target)) setPage(target, { scroll: true });
            });
        });

        if (prevBtn) {
            prevBtn.addEventListener('click', e => {
                e.preventDefault();
                setPage(parseInt(container.dataset.currentPage, 10) - 1, { scroll: true });
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', e => {
                e.preventDefault();
                setPage(parseInt(container.dataset.currentPage, 10) + 1, { scroll: true });
            });
        }

        const initial = parseInt(container.dataset.currentPage, 10) || 1;
        setPage(initial);
    });
}
